import React from 'react';
import {ComponentType, ReactNode} from 'react';
import {useHistory} from 'react-router';
import {ScreenContainer} from '@zvne/fe-framework/dist/presentation/navigation/navigation';
import {useTheme} from '@zvne/fe-framework/dist/presentation/theme/theme-context';
import {TitleSwitcher} from '@zvne/fe-framework/dist/presentation/navigation/title-switcher';
import {NavigationBar} from '@zvne/fe-framework/dist/presentation/navigation/navigation-bar';
import {LanguageSelectDropdown} from '@zvne/fe-framework/dist/presentation/language/language-select-dropdown';
import {ThemeSwitchButton} from '@zvne/fe-framework/dist/presentation/theme/theme-switch-button';
import {Breadcrumbs} from '@zvne/fe-framework/dist/presentation/navigation/breadcrumbs';
import {ToastProvider} from '@zvne/fe-framework/dist/presentation/toast/toast-provider';
import {ConfirmProvider} from '@zvne/fe-framework/dist/presentation/confirm/confirm-provider';
import {useStrings} from '@zvne/fe-framework/dist/presentation/language/strings';
import {strings} from './strings';
import {navigation} from './navigation';
import {AuthScreen} from './screens/auth/auth-screen';
import {LoginLogoutButton} from './reusable/auth/login-logout-button';
import {useAuth} from './reusable/auth/auth-context';

export function screenHoc<P>(
    WrappedComponent: ComponentType<P>,
    container: ScreenContainer = containerStandard,
    authGuardPassed: boolean
): ComponentType<P> {
    return function ScreenComponent(props: P) {
        const theme = useTheme();
        const auth = useAuth();
        const history = useHistory();
        const s = useStrings(strings);
        const screenRender = authGuardPassed ?
            container(<WrappedComponent {...props}/>) :
            containerFill(<AuthScreen/>);
        return (
            <ToastProvider>
                <ConfirmProvider>
                    <TitleSwitcher
                        navigation={navigation}
                        mainTitle={s.title}
                    />
                    <div /*This div fixes the flexbox container in a flexbox container issue on Android Chrome.*/>
                        <NavigationBar
                            navigation={navigation}
                            auth={auth}
                            brand={s.title}
                            rightItems={
                                <>
                                    <LanguageSelectDropdown/>
                                    <ThemeSwitchButton/>
                                    <LoginLogoutButton/>
                                </>
                            }
                            navbarProps={{
                                bg: theme === 'light' ? 'primary' : 'dark',
                                variant: 'dark',
                                expand: 'lg'
                            }}
                            brandProps={{
                                onClick: () => history.push('/')
                            }}
                        />
                    </div>
                    <Breadcrumbs navigation={navigation}/>
                    {screenRender}
                </ConfirmProvider>
            </ToastProvider>
        );
    };
}

export function containerStandard(children: ReactNode) {
    return <div className={'screen-container container'}>{children}</div>;
}

export function containerFluid(children: ReactNode) {
    return <div className={'screen-container container-fluid'}>{children}</div>;
}

export function containerFill(children: ReactNode) {
    return <div className={'screen-container'}>{children}</div>;
}
